module.exports = __webpack_public_path__ + "static/media/logo_GWO_sygnet.91ca8336.svg";